import React from 'react';
import './Bimenamesalessayer.css';
import {framework} from 'saffroncodejs';
import Config from '../../Core/Config.js';
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
var PageManager = framework.PageManager ;
var $ = require('jquery');
class Bimenamesalessayer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      CodeYekta: "",
      CodeMelli:"",
    };
    this.setCodeMelli = this.setCodeMelli.bind(this);
    this.setCodeYekta = this.setCodeYekta.bind(this);
  }
  
  setCodeMelli(event){
    this.setState({CodeMelli:event.target.value});
    $('#exampleNumber').addClass('num_line');
    $('#exampleNumber').removeClass('num_redline');
}

setCodeYekta(event){
    this.setState({CodeYekta:event.target.value});
    $('#examplecodeyekta').addClass('num_line');
    $('#examplecodeyekta').removeClass('num_redline');
}

sendResult() {
  if(this.state.CodeMelli===''|| this.state.CodeYekta==='')
  {
    $('#examplecodeyekta').addClass('num_redline');
    $('#examplecodeyekta').removeClass('num_line');

    $('#exampleNumber').addClass('num_redline');
    $('#exampleNumber').removeClass('num_line');

  }
else
{
  PageManager.changePage(Config.p_bimesalessayerresult,[this.state.CodeMelli,this.state.CodeYekta
  ])
}
}

  
  render() {
    return (
      
        <div>
        <Row>
            <Col sm="12" className="alignRight title">
                <h4>مشخصات بیمه نامه معتبر</h4>
            </Col>
        </Row>
      <div className="Inquiry-form">

        <div className="container-fluid Inquiry">
          <div className="container">
            <Form >
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                <Label for="exampleNumber " sm={3} >کد یکتا بیمه نامه</Label>
                <Col sm={9}>
                  <Input type="text" pattern="[0-9]*"   value={this.state.CodeYekta} onChange={this.setCodeYekta} name="codeyekta" id="examplecodeyekta" placeholder="" />
                </Col>
              </FormGroup>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                <Label for="exampleNumber" sm={3}>کد ملی</Label>
                <Col sm={9}>
                  <Input type="text" pattern="[0-9]*"   value={this.state.CodeMelli} name="codmeli"  onChange={this.setCodeMelli} id="exampleNumber" placeholder="" />
                </Col>
              </FormGroup>
<br/>
              <div className="buttons">
             
            
                {}
                 
                <Button onClick={()=>this.sendResult()}>
                خروجی</Button>

              </div>
              <br/>
              <br/>
            </Form>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

export default Bimenamesalessayer ;


// WEBPACK FOOTER //
// ./src/components/EtelaatBimeSayerSherkatha/Bimenamesalessayer.js